import { commonConfig } from "./environment.common";

export const environment = {
    production: true,
    encryptionKey: 'SICA-APP-KEY',
    appVersion: require('../../package.json').version + '-dev',
    DOMAIN: 'https://dev.sica-app.com',
    showErrors: true,
    environmentName: 'dev',
    ...commonConfig,

    // IDENTITY_URL: 'https://localhost:6001/',
    //RESOURCE_API: 'https://localhost:5002/',

    IDENTITY_URL: 'https://dev.identity.sica-app.com/',
    RESOURCE_API: 'https://dev.ressources.sica-app.com/',
    CLONE_APP: 'https://clone.sica-app.com',
    TERA_RESOURCE_API: 'https://dev.gw.tera-app.com/',
    JOTFORM_URL: 'https://form.jotform.com/253101527062344',
    EXTERNAL_GOOGLE_AUTH_URL: 'api/auth/external/google?returnUrl=https://dev.sica-app.com/splashscreen',
    EXTERNAL_MICROSOFT_AUTH_URL: 'api/auth/external/microsoft?returnUrl=https://dev.sica-app.com/splashscreen',
    RECAPTCHA_SITE_KEY: '6LctI4csAAAAAKTaPCf96wO35x3mh_h0Yw0vmkbP',


    GEO_PORTAL: 'https://www.geoportail.gouv.fr/carte?c=${longitude},${latitude}&z=20&l0=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2::GEOPORTAIL:OGC:WMTS(1)&l1=CADASTRALPARCELS.PARCELLAIRE_EXPRESS::GEOPORTAIL:OGC:WMTS(1)&permalink=yes',
    CADASTRE_URL: 'https://data.geopf.fr/geocodage/reverse?gp-access-lib=3.4.2&index=parcel&searchgeom={"type":"Circle","coordinates":[${longitude},${latitude}],"radius":100}&lon=${longitude}&lat=${latitude}&limit=1',

    // Tracking 
    MATOMO_APP_ID: 3,
    CLARITY_PROJECT_ID: 'to04n3insa',
};

